import React from 'react';
import type { UserManagementListingPermissionDto } from '@zg-rentals/rental-manager-env';
import {
  DatarouterError,
  LoadingStates,
  RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission,
} from '@zg-rentals/rental-manager-env';
import { Alert, Button, ButtonGroup, Heading, Modal, Spacer, Text, TextButton } from '@zillow/constellation-10';

interface AddListingPermissionModalProps {
  onClose: (refresh: boolean) => void;
  permissionToRemove: UserManagementListingPermissionDto;
  listingAlias: string;
}

export const RemoveListingPermissionModal = ({
  onClose,
  permissionToRemove,
  listingAlias,
  shouldOpen = false,
}: AddListingPermissionModalProps & { shouldOpen?: boolean }) => {
  const [errorMessage, setErrorMessage] = React.useState('');
  const [loadingState, setLoadingState] = React.useState(LoadingStates.INITIAL);
  const [open, setOpen] = React.useState(shouldOpen);

  const handleClose = () => {
    setErrorMessage('');
    setLoadingState(LoadingStates.INITIAL);
    onClose(false);
  };

  const renderBody = () => (
    <Spacer css={{ padding: 'md' }}>
      <Text>
        Are you sure you would like to remove <Text textStyle="body-sm-bold">{permissionToRemove.email}</Text>
      </Text>
      {errorMessage && <Alert tone="critical">{errorMessage}</Alert>}
    </Spacer>
  );

  const handleRemovePermission = () => {
    RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission({
      userToken: permissionToRemove.userToken,
      listingAlias,
    })
      .then(() => {
        setErrorMessage('');
        onClose(true);
        return;
      })
      .catch((error) => {
        setLoadingState(LoadingStates.ERROR);
        setErrorMessage(DatarouterError.getDisplayMessage(error));
      });
  };

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        if (!next) handleClose();
      }}
      size="sm"
      header={<Heading level={6}>Remove User</Heading>}
      body={renderBody()}
      footer={
        <ButtonGroup aria-label="Modal actions">
          <TextButton onClick={handleClose}>Cancel</TextButton>
          <Button onClick={handleRemovePermission} loading={loadingState === LoadingStates.LOADING}>
            Remove
          </Button>
        </ButtonGroup>
      }
    />
  );
};
